import { CheckCircle, SyncProgress, XCircle } from '@/assets/icons'

export type AgentProgressStepStatus = 'active' | 'complete' | 'cancelled' | 'error'

const kSrStatusText: Record<AgentProgressStepStatus, string | null> = {
  active: null,
  complete: 'completed',
  cancelled: 'cancelled',
  error: 'failed',
}

export function AgentProgressStep({ label, status }: { label: string; status: AgentProgressStepStatus }) {
  const active = status === 'active'
  const done = status === 'complete'
  const icon = done ? <CheckCircle className="h-5 w-5" /> : active ? <SyncProgress className="h-5 w-5" /> : <XCircle className="h-5 w-5" />

  return (
    <div className="flex items-start gap-2 text-sm font-medium leading-6 tracking-[-0.32px] text-brand-neutral-600">
      <div aria-hidden className="flex h-6 shrink-0 items-center">
        {icon}
      </div>
      <span className={active ? 'animate-shimmer-neutral' : undefined}>
        {label}
        {kSrStatusText[status] && <span className="sr-only"> ({kSrStatusText[status]})</span>}
      </span>
    </div>
  )
}
